/*
 * Magnimoo stale-US-country correction (Europe market focus fix wave 2026-10-20, ruling R22).
 *
 * Since 2026-10-20 the root magnimoo.com market is "Europe & international" in EUR and there is no US
 * shipping zone. A returning visitor who still carries an old `localization=US` cookie (set while the
 * backup region was US) gets every page rendered for the US: Shopify.country === 'US', and every
 * product shows Sold out.
 *
 * Once per browser session, when ALL of these hold:
 *   - window.Shopify.country === 'US'                    (the server rendered this page for the US)
 *   - MagnimooGeo.country() resolves to a valid two-letter code that is not 'US'   (IP-detected,
 *     assets/magnimoo-geo.js, loaded before this file; ?mm_geo=XX forces XX, ?mm_geo=fail forces null)
 *   - sessionStorage works and sessionStorage['mm_country_fixed'] is unset
 * it sets that flag (and checks it stuck), then submits Shopify's own localization form
 * (snippets/magnimoo-country-fix.liquid, rendered only on pages the server rendered for the US) with
 * country_code=<detected> and return_to=<current path + query, without mm_geo>. Shopify stores the new
 * localization and redirects back; it drops a `country` parameter from return_to by itself.
 *
 * Never acts for a real US visitor (detected US), for an unknown country (null), when Shopify.country is
 * anything other than 'US', or twice in one session. No sessionStorage (or a flag that does not stick):
 * no action, so there is no loop risk. Any error: no action (fail open). Server HTML, prices and buy
 * buttons are untouched, so Googlebot never depends on this.
 */
(function () {
  'use strict';
  if (window.__mmCountryFix) return;
  window.__mmCountryFix = true;

  var FLAG = 'mm_country_fixed';
  var FORM_ID = 'MagnimooCountryFixForm';
  var CODE = /^[A-Z]{2}$/;

  // The session store, or null when it is missing or unusable (blocked storage, sandboxed frames).
  function sessionStore() {
    try {
      var store = window.sessionStorage;
      if (!store) return null;
      store.getItem(FLAG); // throws when access is denied
      return store;
    } catch (e) {
      return null;
    }
  }

  // Current path + query without the mm_geo test override.
  function returnTo() {
    var params = new URLSearchParams(window.location.search);
    params.delete('mm_geo');
    var query = params.toString();
    return window.location.pathname + (query ? '?' + query : '');
  }

  function correct(detected, store) {
    var code = typeof detected === 'string' ? detected.toUpperCase() : '';
    if (!CODE.test(code) || code === 'US') return;
    if (!window.Shopify || window.Shopify.country !== 'US') return;
    if (store.getItem(FLAG)) return;

    var form = document.getElementById(FORM_ID);
    if (!form || typeof form.submit !== 'function') return;
    var countryInput = form.querySelector('input[name="country_code"]');
    var returnInput = form.querySelector('input[name="return_to"]');
    if (!countryInput || !returnInput) return;

    store.setItem(FLAG, code);
    if (store.getItem(FLAG) !== code) return; // the flag must stick, or a reload could repeat this
    countryInput.value = code;
    returnInput.value = returnTo();
    form.submit();
  }

  try {
    if (!window.Shopify || window.Shopify.country !== 'US') return;
    var geo = window.MagnimooGeo;
    if (!geo || typeof geo.country !== 'function') return;
    var store = sessionStore();
    if (!store || store.getItem(FLAG)) return;
    var pending = geo.country();
    if (!pending || typeof pending.then !== 'function') return;
    pending.then(function (detected) {
      try {
        correct(detected, store);
      } catch (e) { /* fail open */ }
    }, function () { /* fail open */ });
  } catch (e) { /* fail open */ }
})();
